const brandsPage = {
  init: () => {
    const fetchBrand = (brandHandle, linkList, brandView) =>
      fetch(`/collections/${brandHandle}?view=page-brands-endpoint${linkList ? `&link-list=${linkList}` : ''}${brandView ? `&brand-view=${brandView}` : ''}&page=${Date.now()}`)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          } else {
            const responseData = response.text();
            return responseData;
          }
        })
        .catch((e) => {
          console.log('There has been a problem with your fetch operation: ' + e.message);
        });

    const handleMobileList = (mobileList, boolean) => {
      if (!boolean && !mobileList.classList.contains('open')) {
        mobileList.classList.add('open');
        return;
      }
      mobileList.classList.remove('open');
    };

    const handleModal = (modal, boolean) => {
      if (!boolean && !modal.classList.contains('open')) {
        modal.classList.remove('close');
        modal.classList.add('open');
        return;
      }
      modal.classList.remove('open');
      modal.classList.add('close');
    };

    const handleActiveList = async (event, element, linkContainers, mobileList) => {
      document.removeEventListener('scroll', handleAlphabeticalScroll);

      linkContainers.forEach((container) => (container !== element.parentNode ? container.classList.remove('active') : container.classList.add('active')));

      const dataset = event.currentTarget.dataset;

      // handle clicking of parent brands container
      if (dataset.brandView) {
        const brandsData = await fetchBrand('all', dataset.linkList, dataset.brandView);
        const currentNode = document.querySelector('.brandspage-content');
        window.scrollTo({ top: currentNode, behavior: 'smooth' });
        const newNode = document.createElement('div');
        newNode.classList.add('brandspage-content');
        newNode.innerHTML = brandsData;
        const brandEls = newNode.querySelectorAll('.brand-list-item > .content-container');
        brandEls.forEach((element) => element.addEventListener('click', handleActiveBrand));
        currentNode.replaceWith(newNode);

        if (dataset.brandView === 'alphabetical-logo-list') {
          const brandLetterEls = newNode.querySelectorAll('.brand-letter');
          brandLetterEls.forEach((element) => element.addEventListener('click', () => handleLetterClick(element)));
          document.addEventListener('scroll', handleAlphabeticalScroll);
        }

        mobileList.innerHTML = dataset.title;
        handleMobileList(mobileList, true);

        return;
      }
    };

    const handleActiveBrand = async (event) => {
      const dataset = event.currentTarget.dataset;

      // handle clicking of individual brand
      if (dataset.brandHandle) {
        const brandData = await fetchBrand(dataset.brandHandle);
        const currentNode = document.querySelector('.brand-modal-view .body');
        const newNode = document.createElement('div');
        newNode.classList.add('body');
        newNode.innerHTML = brandData;
        currentNode.replaceWith(newNode);

        handleModal(modal, false);
        if (typeof yotpoWidgetsContainer !== 'undefined' && typeof yotpoWidgetsContainer.initWidgets !== 'undefined') {
          yotpoWidgetsContainer.initWidgets();
        }
        return;
      }
    };

    const handleLetterClick = async (element) => {
      const lettersNav = document.querySelector('.letters-container');
      const anchor = document.querySelector(`a[name='${element.dataset.brandLetter}']`);
      if (window.matchMedia('(max-width:749px)').matches) {
        const brandsMenu = document.querySelector('.brands-page-menu');
        window.scrollTo({ top: anchor.offsetTop - lettersNav.clientHeight - brandsMenu.clientHeight, behavior: 'smooth' });
        return;
      }
      window.scrollTo({ top: anchor.offsetTop + lettersNav.clientHeight, behavior: 'smooth' });
      return;
    };

    const handleAlphabeticalScroll = () => {
      const navLetters = document.querySelectorAll('.brand-letter');
      const header = document.querySelector('.shopify-section-group-group_header');
      const lettersNav = document.querySelector('.letters-container');

      if (navLetters && window.pageYOffset > header.offsetTop) {
        navLetters.forEach((element) => element.classList.remove('active'));
        navLetters[0].classList.add('active');
        navLetters.forEach((element, index) => {
          const anchor = document.querySelector(`a[name='${element.dataset.brandLetter}']`);
          if (window.matchMedia('(max-width:749px)').matches) {
            const brandsMenu = document.querySelector('.brands-page-menu');
            if (window.pageYOffset >= anchor.offsetTop - lettersNav.clientHeight - brandsMenu.clientHeight) {
              navLetters.forEach((element) => element.classList.remove('active'));
              element.classList.add('active');
              return;
            }
            return;
          }
          if (window.pageYOffset >= anchor.offsetTop + lettersNav.clientHeight) {
            navLetters.forEach((element) => element.classList.remove('active'));
            element.classList.add('active');
            return;
          }
        });
      }

      return;
    };

    const mobileActiveListEl = document.querySelector('.mobile-active-list');
    mobileActiveListEl.addEventListener('click', () => handleMobileList(mobileActiveListEl, false));

    // get linkLists and tether click event listeners
    const linkListContainerEls = document.querySelectorAll('.link-list');
    if (linkListContainerEls.length > 0) {
      linkListContainerEls.forEach((element) => {
        const linkListEls = element.querySelectorAll('h2');
        const brandLinkEls = element.querySelectorAll('.link-to-brand');
        linkListEls.forEach((linkListEl) => linkListEl.addEventListener('click', (event) => handleActiveList(event, linkListEl, linkListContainerEls, mobileActiveListEl)));
        brandLinkEls.forEach((brandEl) => brandEl.addEventListener('click', handleActiveBrand));
      });
    }

    // get modal and tether click event listeners
    const modal = document.querySelector('.brand-modal-view');
    const closeModal = modal.querySelector('.close');
    modal.addEventListener('click', (event) => (event.target === modal ? handleModal(modal, false) : null));
    closeModal.addEventListener('click', () => handleModal(modal, false));
  },
};

document.addEventListener('DOMContentLoaded', (event) => {
  brandsPage.init();
});
